module.exports = __webpack_public_path__ + "static/media/ClinicaDelSol.01926fc6.svg";